import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowDatePickerToolbar } from './datepickertoolbar.theme';

export const flowTimePickerToolbar: Components<Theme>['MuiTimePickerToolbar'] = {
  ...(flowDatePickerToolbar as Components<Theme>['MuiTimePickerToolbar']),
};
